import Button from "../../../../../appl/view/components/buttons/Button";

export default function FahaTest() {
  return <div className='bg-cn-color-black-804 flex justify-center p-5'>
    <div className='w-56'>

      <Button color='secondary' tooltip='test'>Test</Button>

    </div>
  </div>
}